import { useContext } from 'react';

import { Tkv2OrderContext } from '../Tkv2OrderContext.ts';
import { Tkv2OrderContext as Tkv2OrderContextType } from '../types.ts';

export function useTkv2OrderContext(): Tkv2OrderContextType {
  const orderContext = useContext(Tkv2OrderContext);

  if (orderContext) return orderContext;

  throw new Error('useTkv2OrderContext must be used within a Tkv2OrderContext and once setup');
}
